<!-- 사용법 : dksteel, 747 참고 -->

<template>
  <div>
    <div v-if="title" class="mb-4">
      <div>
        <h5><i class="dot"></i>{{ title }}</h5>
      </div>
    </div>
    <div class="writeGridContainer">
      <div v-for="(label, index) in labels"
           :class="classes[index]">
        <div>{{ label }}</div>
        <slot
          :index="index"
          :label="label"
          :value="values[index]"
          :dataType="dataTypes[index]"
        >
          <div>
            <ml-input class="default-input" v-model="form[values[index]]" />
            <div class="printing print-input">{{form[values[index]]}}</div>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: Object,
    label: String,
    title: String,
    options: {
      type: Object,
      default: () => {
        return {
          labels: [],
          values: []
        }
      }
    },
  },
  computed: {
    form: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    labels () {
      try {
        return this.options.labels || []
      } catch (e) {}
      return []
    },
    classes () {
      try {
        return this.options.classes || []
      } catch (e) {}
      return []
    },
    values () {
      const values = []
      for (const label of this.labels) {
        values.push(`input_${values.length+1}`)
      }
      try {
        return this.options.values || values
      } catch (e) {}
      return values
    },
    dataTypes () {
      try {
        return this.options.dataTypes || []
      } catch (e) {}
      return []
    }
  }
}
</script>
<style scoped>
.printing {
  display: none;
}
@media print {
  .default-input {
    display: none;
  }
  .printing {
    display: block;
  }
}
</style>
